import React from 'react'

import { Field } from 'formik'

import { AdminContext } from 'contexts/AdminContext'

import { Form, Col } from '_zari/core'

const FechaVencimientoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const __adminContext = React.useContext(AdminContext)

  return (
    <Form.Group>
      <Form.Label text='FEC. VENCIMIENTO' htmlFor='date-fechaVencimiento' md={6} alignRightAt='md' />
      <Col md={6}>
        <Field name='fechaVencimiento'>
          {({ field }) => (
            <Form.InputDate
              {...field}
              id='date-fechaVencimiento'
              disabled={fIsSubmitting || !__adminContext.valoresConfiguracionUsuario.flagCambioFecha}
              isInvalid={iTouched && iError}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaVencimientoFormGroup)
